export const FIXED_BODY_CLASS = 'fixed';
export const CHANGE_BODY_FIXED_EVENT = 'change-body-fixed';
export const BODY_SCROLLBAR_WIDTH_CSS_VARIABLE = '--body-scrollbar-width';

export const getScrollbarWidth = () => {
    const hasScrollbar = document.documentElement.scrollHeight > window.innerHeight;
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return {
        scrollbarWidth,
        hasScrollbar,
    };
};

export const observerCallback = () => {
    const body = document.body;
    const hasFixedClass = body.classList.contains(FIXED_BODY_CLASS);
    const { scrollbarWidth, hasScrollbar } = getScrollbarWidth();
    let cssValue = 0;

    if (hasFixedClass && hasScrollbar) {
        cssValue = scrollbarWidth;
    }

    document.documentElement.style.setProperty(BODY_SCROLLBAR_WIDTH_CSS_VARIABLE, `${cssValue}px`);
    document.dispatchEvent(
        new CustomEvent(CHANGE_BODY_FIXED_EVENT, {
            detail: {
                scrollbarWidth,
                hasFixedClass,
                cssValue,
                hasScrollbar,
                body,
            },
        })
    );
};

export const documentObserver = new MutationObserver(observerCallback);
